import { useDetailPanelSafe } from '../../../ui/DetailPanel';
import { FullscreenOverlayHeader } from '../../../ui/FullscreenOverlay';
import type { FullscreenOverlayHeaderProps } from '../../../ui/FullscreenOverlay';

type HaloSpokeHeaderProps = Omit<FullscreenOverlayHeaderProps, 'closeLabel'>;

export const HaloSpokeHeader = (props: HaloSpokeHeaderProps) => {
  const context = useDetailPanelSafe();
  return <FullscreenOverlayHeader {...props} closeLabel={context?.closeLabelShort ?? context?.closeLabel} />;
};
